import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeLayers,
  FontAwesomeLayersText,
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  addCircle as cecilianaxisicons_addCircle,
  addSquare as cecilianaxisicons_addSquare,
  apps as cecilianaxisicons_apps,
  appointment as cecilianaxisicons_appointment,
  arrowDropDown as cecilianaxisicons_arrowDropDown,
  arrowDropUp as cecilianaxisicons_arrowDropUp,
  arrowDownward as cecilianaxisicons_arrowDownward,
  arrowUpward as cecilianaxisicons_arrowUpward,
  artboard as cecilianaxisicons_artboard,
  augmentedReality as cecilianaxisicons_augmentedReality,
  backUi as cecilianaxisicons_backUi,
  brickWall as cecilianaxisicons_brickWall,
  calendar as cecilianaxisicons_calendar,
  calendarMonth as cecilianaxisicons_calendarMonth,
  car as cecilianaxisicons_car,
  caretLeft as cecilianaxisicons_caretLeft,
  caretRight as cecilianaxisicons_caretRight,
  chevronLeft as cecilianaxisicons_chevronLeft,
  chevronRight as cecilianaxisicons_chevronRight,
  chartPie1 as cecilianaxisicons_chartPie1,
  checkmarkCircle as cecilianaxisicons_checkmarkCircle,
  checkmarkSquareOutlined as cecilianaxisicons_checkmarkSquareOutlined,
  clear as cecilianaxisicons_clear,
  clearCircle as cecilianaxisicons_clearCircle,
  commentVsOutlined as cecilianaxisicons_commentVsOutlined,
  dashboard as cecilianaxisicons_dashboard,
  dashboardOutlined as cecilianaxisicons_dashboardOutlined,
  dashboardVsOutlined as cecilianaxisicons_dashboardVsOutlined,
  dataSharing as cecilianaxisicons_dataSharing,
  dollarOutlined as cecilianaxisicons_dollarOutlined,
  done as cecilianaxisicons_done,
  downUi as cecilianaxisicons_downUi,
  downloadFromCloud as cecilianaxisicons_downloadFromCloud,
  edit as cecilianaxisicons_edit,
  envelope as cecilianaxisicons_envelope,
  fileAddOutlined as cecilianaxisicons_fileAddOutlined,
  filter as cecilianaxisicons_filter,
  filterOptions as cecilianaxisicons_filterOptions,
  folderPhoto as cecilianaxisicons_folderPhoto,
  fullscreen11 as cecilianaxisicons_fullscreen11,
  fullscreen43 as cecilianaxisicons_fullscreen43,
  google as cecilianaxisicons_google,
  heart as cecilianaxisicons_heart,
  heartOutlined as cecilianaxisicons_heartOutlined,
  home as cecilianaxisicons_home,
  homeVs2Outlined as cecilianaxisicons_homeVs2Outlined,
  info as cecilianaxisicons_info,
  link as cecilianaxisicons_link,
  map as cecilianaxisicons_map,
  leftKey as cecilianaxisicons_leftKey,
  map2d as cecilianaxisicons_map2d,
  map3d as cecilianaxisicons_map3d,
  mapOutlined as cecilianaxisicons_mapOutlined,
  menuHamburger as cecilianaxisicons_menuHamburger,
  moreHorizontal as cecilianaxisicons_moreHorizontal,
  moreVertical as cecilianaxisicons_moreVertical,
  myLocation as cecilianaxisicons_myLocation,
  navigate as cecilianaxisicons_navigate,
  nextUi as cecilianaxisicons_nextUi,
  neighborhood as cecilianaxisicons_neighborhood,
  notifications as cecilianaxisicons_notifications,
  password as cecilianaxisicons_password,
  photoLandscapeOutlined as cecilianaxisicons_photoLandscapeOutlined,
  rightKey as cecilianaxisicons_rightKey,
  receiptOutlined as cecilianaxisicons_receiptOutlined,
  refresh as cecilianaxisicons_refresh,
  restore as cecilianaxisicons_restore,
  save as cecilianaxisicons_save,
  search as cecilianaxisicons_search,
  table as cecilianaxisicons_table,
  telegram as cecilianaxisicons_telegram,
  thumbsUp as cecilianaxisicons_thumbsUp,
  thumbsDown as cecilianaxisicons_thumbsDown,
  trash as cecilianaxisicons_trash,
  upUi as cecilianaxisicons_upUi,
  user as cecilianaxisicons_user,
  warning as cecilianaxisicons_warning,
  warningOutlined as cecilianaxisicons_warningOutlined
} from '@cecilian/axis-icons'

library.add(
  cecilianaxisicons_addCircle,
  cecilianaxisicons_addSquare,
  cecilianaxisicons_apps,
  cecilianaxisicons_appointment,
  cecilianaxisicons_arrowDropDown,
  cecilianaxisicons_arrowDropUp,
  cecilianaxisicons_arrowDownward,
  cecilianaxisicons_arrowUpward,
  cecilianaxisicons_artboard,
  cecilianaxisicons_augmentedReality,
  cecilianaxisicons_backUi,
  cecilianaxisicons_brickWall,
  cecilianaxisicons_calendar,
  cecilianaxisicons_calendarMonth,
  cecilianaxisicons_car,
  cecilianaxisicons_caretLeft,
  cecilianaxisicons_caretRight,
  cecilianaxisicons_chevronLeft,
  cecilianaxisicons_chevronRight,
  cecilianaxisicons_chartPie1,
  cecilianaxisicons_checkmarkCircle,
  cecilianaxisicons_checkmarkSquareOutlined,
  cecilianaxisicons_clear,
  cecilianaxisicons_clearCircle,
  cecilianaxisicons_commentVsOutlined,
  cecilianaxisicons_dashboard,
  cecilianaxisicons_dashboardOutlined,
  cecilianaxisicons_dashboardVsOutlined,
  cecilianaxisicons_dataSharing,
  cecilianaxisicons_dollarOutlined,
  cecilianaxisicons_done,
  cecilianaxisicons_downUi,
  cecilianaxisicons_downloadFromCloud,
  cecilianaxisicons_edit,
  cecilianaxisicons_envelope,
  cecilianaxisicons_fileAddOutlined,
  cecilianaxisicons_filter,
  cecilianaxisicons_filterOptions,
  cecilianaxisicons_folderPhoto,
  cecilianaxisicons_fullscreen11,
  cecilianaxisicons_fullscreen43,
  cecilianaxisicons_google,
  cecilianaxisicons_heart,
  cecilianaxisicons_heartOutlined,
  cecilianaxisicons_home,
  cecilianaxisicons_homeVs2Outlined,
  cecilianaxisicons_info,
  cecilianaxisicons_link,
  cecilianaxisicons_map,
  cecilianaxisicons_leftKey,
  cecilianaxisicons_map2d,
  cecilianaxisicons_map3d,
  cecilianaxisicons_mapOutlined,
  cecilianaxisicons_menuHamburger,
  cecilianaxisicons_moreHorizontal,
  cecilianaxisicons_moreVertical,
  cecilianaxisicons_myLocation,
  cecilianaxisicons_navigate,
  cecilianaxisicons_nextUi,
  cecilianaxisicons_neighborhood,
  cecilianaxisicons_notifications,
  cecilianaxisicons_password,
  cecilianaxisicons_photoLandscapeOutlined,
  cecilianaxisicons_rightKey,
  cecilianaxisicons_receiptOutlined,
  cecilianaxisicons_refresh,
  cecilianaxisicons_restore,
  cecilianaxisicons_save,
  cecilianaxisicons_search,
  cecilianaxisicons_table,
  cecilianaxisicons_telegram,
  cecilianaxisicons_thumbsUp,
  cecilianaxisicons_thumbsDown,
  cecilianaxisicons_trash,
  cecilianaxisicons_upUi,
  cecilianaxisicons_user,
  cecilianaxisicons_warning,
  cecilianaxisicons_warningOutlined
)

config.autoAddCss = false

Vue.component('fa', FontAwesomeIcon)
Vue.component('faLayers', FontAwesomeLayers)
Vue.component('faLayersText', FontAwesomeLayersText)
